var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import OtpInputVendor from '../vendors/ReactOtpInput';
import styled from 'styled-components';
var HelperTextLabel = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 20px;\n  color: ", ";\n  font-size: 16px;\n  line-height: 20px;\n"], ["\n  margin-top: 20px;\n  color: ", ";\n  font-size: 16px;\n  line-height: 20px;\n"])), function (props) {
    return props.error ? props.theme.colors.warning : props.theme.colors.textBodyAdd;
});
export var OTPInput = function (_a) {
    var value = _a.value, onChange = _a.onChange, isError = _a.isError, helperText = _a.helperText, otpLength = _a.otpLength;
    var handleChange = useCallback(function (otp) {
        onChange(otp);
    }, [onChange]);
    return (_jsxs("div", { children: [_jsx(OtpInputVendor, { shouldAutoFocus: true, inputMode: "decimal", placeholder: "00000", isError: isError, value: value, numInputs: otpLength, onChange: handleChange }), _jsx(HelperTextLabel, __assign({ error: isError }, { children: helperText }))] }));
};
var templateObject_1;
